import React, {
  createRef,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import SliderControls from "../../../../components/SliderControls";
import useTileScroller from "../../../../hooks/useTileScroller";
import { avatarObj, avatarOptions } from "./avatarCustomisationData";
import styles from "./index.module.scss";
import CustomAvatar from "../CustomAvatar";
import { AvatarContext } from "../../../../contexts/AvatarContext/AvatarContextProvider";
import * as htmlToImage from "html-to-image";
import { uploadAvatarImages } from "../../../../Managers/Avatar";
import { UserContext } from "../../../../contexts/UserContext/UserContextProvider";
import AvatarManager from "../../../../Managers/Users/Avatar";
import LoaderImg from "../../../../assets/images/Loader.gif";

const ProfileScreen = ({ UserAvatarDetails, camImage, handleCloseAvatar }) => {
  const { currentIndex, updateIndex } = useTileScroller({
    noOfTiles: 5,
    onEndReached: () => {},
    elementId: "recentSection",
    mobileTileWidth: 300,
    webTileWidth: 100,
    tileGapWeb: -100,
    webTileId: "recentCard",
    autoScrollToCard: false,
    indexing: true,
  });
  const LastGenderSelected = useRef(null);

  const { user, userBasicDetails } = useContext(UserContext);
  const [loading, setLoading] = useState(false);
  // const [avatarCustomisationOptions, setAvatarCustomisationOptions] = useState(
  //   []
  // );
  const {
    handleUpdateAvatar,
    handleScreen,
    state,
    handleAvatar,
    handleInitialConfiguration,
    handleGenderChange,
    addDetails,
    handleSave,
  } = useContext(AvatarContext);

  const avatarBody = createRef(null);

  // const avatarDownload = createRef(null);

  const saveAvatar = async () => {
    setLoading(true);
    let configuration = {};
    Object.values(avatarObj[state.gender]).forEach((avatar) => {
      if (avatar.multiple) {
        configuration[avatar.id] = [];
        Object.values(avatar.options).forEach((item) => {
          if (state.hasOwnProperty(item.id)) {
            configuration[avatar.id].push({ id: state[item.id].id });
          }
        });
      } else if (state.hasOwnProperty(avatar.id)) {
        //active id and ids are different for third layer
        if (state[avatar.id].id !== state[avatar.id].active) {
          configuration[avatar.id] = {
            id: state[avatar.id].active,
            option: { id: state[avatar.id].id },
          };
        } else {
          configuration[avatar.id] = {
            id: avatar.options[state[avatar.id].id].id,
          };
        }
      }
    });
    addDetails("avatar_settings", { ...configuration });

    try {
      if (avatarBody.current) {
        htmlToImage
          .toPng(avatarBody.current)
          .then(async function (dataUrl) {
            let url_full_image = await uploadAvatarImages(
              dataUrl,
              "avatarFull",
              user.uid,
              (res) => {
                console.log(res);
              }
            );
            addDetails("avatar_full_img", url_full_image);
            let newImg = new Image();
            newImg.src = dataUrl;

            newImg.onloadstart = () => {};
            newImg.onload = async () => {
              const canvas = document.createElement("canvas");
              const scaleX = newImg.naturalWidth / newImg.width;
              const scaleY = newImg.naturalHeight / newImg.height;
              canvas.width = newImg.width / 3;
              canvas.height = newImg.width / 3;
              const ctx = canvas.getContext("2d");
              // image upload crop
              ctx.drawImage(
                newImg,
                -newImg.width / 2.9,
                -newImg.height / 14,
                newImg.width,
                newImg.height
              );
              const base64Image = canvas.toDataURL("image/png", 1);
              let url_half_image = await uploadAvatarImages(
                base64Image,
                "avatarHalf",
                user.uid,
                (res) => {}
              );
              addDetails("avatar_face_img", url_half_image);

              handleSave("Avatar", {
                id: "avatar_img",
                half_img: url_half_image,
                full_image: url_full_image,
                cam_image: userBasicDetails.avatar
                  ? userBasicDetails.avatar.cam_image
                  : state.cam_image,
                avatar_settings: { ...configuration },
              });

              setLoading(false);
              handleCloseAvatar();
            };
          })
          .catch((e) => console.log(e));
      }
    } catch (err) {
      console.log(err);
    }
  };

  const userUpdateCheck = useRef(false);
  let avatarCustomisationOptions = Object.values(avatarOptions[state.gender]);

  // useEffect(() => {
  //   setAvatarCustomisationOptions(Object.values(avatarOptions[state.gender]));
  // }, [state.gender]);

  const handleSetActiveOption = (value) => {
    updateIndex(value);
  };
  const [subOptions, setSubOptions] = useState({});

  const handleGenderClick = (value) => {
    let configuration = {};
    Object.values(avatarObj[state.gender]).forEach((avatar) => {
      if (avatar.multiple) {
        configuration[avatar.id] = [];
        Object.values(avatar.options).forEach((item) => {
          if (state.hasOwnProperty(item.id)) {
            configuration[avatar.id].push({ id: state[item.id].id });
          }
        });
      } else if (state.hasOwnProperty(avatar.id)) {
        //active id and ids are different for third layer
        if (state[avatar.id].id !== state[avatar.id].active) {
          configuration[avatar.id] = {
            id: state[avatar.id].active,
            option: { id: state[avatar.id].id },
          };
        } else {
          configuration[avatar.id] = {
            id: avatar.options[state[avatar.id].id].id,
          };
        }
      }
    });

    handleGenderChange(value, LastGenderSelected.current);
    Object.values(avatarObj[value]).forEach((avatar) => {
      if (
        LastGenderSelected.current &&
        LastGenderSelected.current.hasOwnProperty(avatar.id)
      ) {
        if (LastGenderSelected.current[avatar.id].option) {
          console.log(
            LastGenderSelected.current[avatar.id].id,
            avatar.id[LastGenderSelected.current[avatar.id].id],
            avatar.options[LastGenderSelected.current[avatar.id].id]
          );

          setSubOptions(
            avatar.options[LastGenderSelected.current[avatar.id].id]
          );
        } else {
          setSubOptions({});
        }
      } else {
        setSubOptions({});
      }
    });

    LastGenderSelected.current = configuration;
  };

  const handleBack = () => {
    handleScreen("screen", "");
  };

  useEffect(() => {
    if (userBasicDetails && !userUpdateCheck.current) {
      handleInitialConfiguration(userBasicDetails, "initial");
      userUpdateCheck.current = true;
    }
  }, [userBasicDetails]);

  const genderOptions = [
    {
      id: "male",
      name: "Male",
    },
    {
      id: "female",
      name: "Female",
    },
  ];

  return (
    <div className={styles.ProfileContainer}>
      <div className={styles.headerBtnsWrapper}>
        <button onClick={handleBack} className={`btn ${styles.Backbtn}`}>
          Back
        </button>
        <div className={styles.genderOptions}>
          {genderOptions.map((gender) => {
            let isActive = gender.id === state.gender;
            return (
              <button
                style={{
                  background: isActive ? "#eb4547" : "transparent",
                  borderTopRightRadius:
                    isActive && state.gender === "female" ? "5rem" : "none",
                  borderBottomRightRadius:
                    isActive && state.gender === "female" ? "5rem" : "none",
                  borderTopLeftRadius:
                    isActive && state.gender === "male" ? "5rem" : "none",
                  borderBottomLeftRadius:
                    isActive && state.gender === "male" ? "5rem" : "none",
                }}
                onClick={() => handleGenderClick(gender.id)}
                className={`btn ${styles.backBtn}`}
              >
                {gender.name}
              </button>
            );
          })}
        </div>
        <button
          disabled={loading}
          onClick={() => saveAvatar()}
          className={`btn ${styles.btn}`}
        >
          {loading ? <img src={LoaderImg} alt="" height="100%" /> : "Save"}
        </button>
      </div>
      <div className={styles.avatarWrapper}>
        <div className={styles.controlsWrapper}>
          <SliderControls
            onPrev={() => {
              setSubOptions({});
              updateIndex(currentIndex - 1);
            }}
            onNext={() => {
              setSubOptions({});
              updateIndex(currentIndex + 1);
            }}
            prevActive={currentIndex > 0}
            nextActive={
              avatarCustomisationOptions.length > 0 &&
              currentIndex < avatarCustomisationOptions.length - 1
            }
            customClass={styles.controls}
          />
        </div>
        <CustomAvatar avatarOptions={avatarOptions} avatarBody={avatarBody} />
      </div>

      <div style={{ position: "relative" }}>
        {Object.values(subOptions).length > 0 && (
          <div className={`${styles.editOptions} ${styles.subOptions}`}>
            {subOptions.options.map((activeOptn) => {
              // //check if multiple
              let multiple = subOptions.multiple;
              let isActive = false;
              if (multiple) {
                // check active of item
                isActive =
                  state[subOptions.id] &&
                  state[subOptions.id].id === activeOptn.id;
              } else {
                isActive =
                  state[subOptions.parentId] &&
                  state[subOptions.parentId].id === activeOptn.id;
              }

              return (
                <div
                  id="recentCard"
                  key={activeOptn.id}
                  className={styles.Color}
                  onClick={() => {
                    handleAvatar(subOptions, activeOptn, multiple);
                  }}
                  style={{
                    outline:
                      activeOptn.color && isActive
                        ? "4px solid #eb4547"
                        : "transparent",
                    backgroundColor: activeOptn.color
                      ? activeOptn.color
                      : isActive
                      ? "#eb4547"
                      : "transparent",
                  }}
                >
                  {activeOptn.optionImg ? (
                    <img
                      className={styles.imgUrl}
                      src={activeOptn.optionImg}
                      alt={activeOptn.name}
                    />
                  ) : null}
                </div>
              );
            })}
          </div>
        )}
      </div>
      <div id="recentSection" className={styles.editOptions}>
        {avatarCustomisationOptions.length > 0 &&
          avatarCustomisationOptions[currentIndex].options.map((activeOptn) => {
            //check if multiple
            let multiple = avatarCustomisationOptions[currentIndex].multiple;
            let isActive = false;
            if (multiple) {
              // check active item
              isActive =
                state[activeOptn.id] &&
                state[activeOptn.id].id === activeOptn.id;
            } else {
              isActive =
                state[activeOptn.parentId] &&
                state[activeOptn.parentId].active === activeOptn.id;
            }

            return (
              <div
                id="recentCard"
                key={activeOptn.id}
                className={styles.Color}
                onClick={() => {
                  if (activeOptn.options) {
                    setSubOptions(activeOptn);
                    if (
                      state[activeOptn.parentId] &&
                      state[activeOptn.parentId].active === activeOptn.id
                    ) {
                    } else {
                      handleAvatar(activeOptn, activeOptn.options[0], multiple);
                    }
                  } else {
                    handleUpdateAvatar(activeOptn, multiple);
                    setSubOptions({});
                  }
                }}
                style={{
                  outline:
                    activeOptn.color && isActive
                      ? "4px solid #eb4547"
                      : "transparent",
                  backgroundColor: activeOptn.color
                    ? activeOptn.color
                    : isActive
                    ? "#eb4547"
                    : "transparent",
                }}
              >
                {activeOptn.optionImg ? (
                  <img
                    className={styles.imgUrl}
                    src={activeOptn.optionImg}
                    alt={activeOptn.name}
                  />
                ) : null}
              </div>
            );
          })}
      </div>
      <div className={styles.avatarOptions}>
        {avatarCustomisationOptions.length > 0 &&
          avatarCustomisationOptions.map((option, index) => (
            <button
              key={option.id}
              style={{
                color: currentIndex === index ? "#eb4547" : "#fff",
                borderBottom:
                  currentIndex === index ? "1px solid #eb4547" : "none",
              }}
              onClick={() => {
                setSubOptions({});
                handleSetActiveOption(index);
              }}
              className={styles.option}
            >
              {option.name}
            </button>
          ))}
      </div>
    </div>
  );
};

export default ProfileScreen;
